<script>
import Vue from 'vue';
import { RichTextEditorPlugin, Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar, Table } from "@syncfusion/ej2-vue-richtexteditor";
Vue.use(RichTextEditorPlugin);
export default {
    name: "ClinicalProfileForm",

    data() {

        return {
            templates: [],
            templateID: 0,
        };
    },

    props: {

        triage: Object,
    },

    watch: {

        templateID() {
            if(!this.templateID) return;

            const templates = this.templates.filter(temp => temp.tempID == this.templateID);

            if(!templates.length) return;

            this.triage.clinicalProfile = templates[0].template;
        },
    },

    provide: {

     richtexteditor:[Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar, Table]
    },

    mounted() {

        this.fetchTemplates();
    },

    methods: {

        fetchTemplates() {

            return this.$http.get(`MedicalFile/GetMedicalNotesTemplateNames`).then(response => {
                this.templates = response.data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
<div class="w-full flex flex-wrap overflow-auto mt-1">
    <div class="md:w-1/4 w-full p-tiny">
        <label for="grid-template-cp" class="label-control">Template:</label>
        <v-select class="text-xs bg-white" 
            :options="templates" 
            :reduce="temp => temp.tempID" 
            v-model="templateID" label="tempName" 
        />
    </div>
    <div class="w-full p-tiny">
        <ejs-richtexteditor ref="clinicalProfileRTE" 
            v-model.trim="triage.clinicalProfile" 
            :height="315" 
            :insertImageSettings="{
                saveFormat: 'Base64'
            }"
            :toolbarSettings= "{
              items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
              'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
              'LowerCase', 'UpperCase', 'SuperScript', 'SubScript' , '|',
              'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
              'Outdent', 'Indent', '|',
              'CreateTable', 'CreateLink', 'Image', '|', 
              'ClearFormat', 'Print', 'SourceCode', 'FullScreen', '|',
              'Undo', 'Redo']
          }">
        </ejs-richtexteditor>
    </div>
</div>
</template>
